import { orderedPackage } from 'services/api/pay';
import { useMount, useRequest } from 'ahooks';
import { atom, useAtom, useAtomValue } from 'jotai';
import { filter, isNull, noop, orderBy } from 'lodash-es';
import * as React from 'react';
import { useAuthorization } from 'components/Authorization';
import { usePackageV2 } from './usePackage';

export const comboInfoState = atom<Pay.OrderedPackage[]>([]);

export const useComboInfo = (force?: boolean) => {
  const { state, loading } = useFetch(force);
  if (loading) return [];
  if (state === null) return [];
  return state;
};

let refreshComboInfoFn = noop;

const useFetch = (force?: boolean) => {
  const [state, setState] = useAtom(comboInfoState);
  const { loading, refreshAsync } = useRequest(orderedPackage, {
    onSuccess: (data) => {
      setState(orderBy(data, 'status', 'desc'));
    },
    manual: true,
  });
  useMount(() => {
    if (isNull(state) || force) {
      refreshAsync();
    }
  });

  React.useEffect(() => {
    refreshComboInfoFn = refreshAsync;
  });

  return {
    loading,
    state,
  };
};

/**
 * 这里通过套餐来判断是否是企业版，和通过qaEnable不同，undefined表示接口在loading
 */
export const useIsEnterprisePkg = (): undefined | boolean => {
  const { state, loading } = useFetch();
  if (loading) return undefined;
  if (isNull(state)) return undefined;
  const pkg = filter(state, (v) => v.id !== 8);
  return pkg[0]?.id === 5;
};

export const refreshComboInfo = () => {
  refreshComboInfoFn?.();
};

export const useOrderedPackagesActions = () => {
  const orderedPackages = useAtomValue(comboInfoState);
  const { payload } = useAuthorization<Oversea.Token.Payload>();
  const { fetch: fetchPackageList } = usePackageV2(payload?.orgId, 'ORDER');
  const [canUpgrade, setCanUpgrade] = React.useState(false);

  useRequest(() => fetchPackageList(), {
    onSuccess({ packageData }) {
      const workingPack = orderedPackages?.find((v) => v.status === 1);

      if (workingPack) {
        if (workingPack.id === 6) {
          // QikChat
          setCanUpgrade(true);
        } else {
          const index = packageData.findIndex((item) => item.id === workingPack.id);
          setCanUpgrade(index < packageData.length - 1);
        }
      }
    },
  });

  const canRenew = React.useMemo(
    () => !orderedPackages?.find((v) => v.status === 0),
    [orderedPackages],
  );

  return {
    canUpgrade,
    canRenew,
  };
};
